import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Homepage from './pages/Homepage.js';
import Leaderboard from './pages/Leaderboard.js';
import Leaderboard1 from './pages/Leaderboard.js';
import Leaderboard2 from './pages/Leaderboard.js';
import Leaderboard3 from './pages/Leaderboard.js';
import Leaderboardv2 from './pages/LeagueDashboard.js';
import Matches from './pages/Matches.js';
import HomeWH40K from './pages/Home.js';
import Armyboard from './pages/Armyboard.js';
import Honor from './pages/Honor.js';
import Player from './pages/Player.js';
import Chronicles from "./pages/Chronicles";

function PageTitleUpdater() {
  const location = useLocation();

  useEffect(() => {
    const titles = {
      '/': 'Inicio - El Cobrador League',
      '/wh40k': 'Warhammer 40K - El Cobrador League',
      '/Leaderboard': 'Leaderboard - El Cobrador League',
      '/Leaderboard1': 'Leaderboard 1 - El Cobrador League',
      '/Leaderboard2': 'Leaderboard 2 - El Cobrador League',
      '/Leaderboard3': 'Leaderboard 3 - El Cobrador League'
    };

    document.title = titles[location.pathname] || 'El Cobrador League';
  }, [location]);

  return null; // No renderiza nada, solo cambia el título
}

function ElCobradorLeague() {
  return (  
    <div className="App">
      <BrowserRouter>
        <PageTitleUpdater /> {/* Componente para actualizar el título dinámicamente */}
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/wh40k" element={<HomeWH40K />} />
          <Route path="/Leaderboard" element={<Leaderboard />} />
          <Route path="/Leaderboard1" element={<Leaderboard1 />} />
          <Route path="/Leaderboard2" element={<Leaderboard2 />} />
          <Route path="/Leaderboard3" element={<Leaderboard3 />} />
          <Route path="/Matches" element={<Matches />} />
          <Route path="/Leaderboardv2" element={<Leaderboardv2 />} />
          <Route path="/Armyboard" element={<Armyboard />} />
          <Route path="/Honor" element={<Honor />} />
          <Route path="/Player" element={<Player />} />
          <Route path="/wh40k/chronicles" element={<Chronicles />} />
        </Routes>    
      </BrowserRouter>
    </div>
  );
}

export default ElCobradorLeague;
